/*
 * Purpose: Server-persisted user state — tenant prefs (no vault secrets)
 * Last modified: 2026-06-28 | Agent
 * Completeness: 92
 */
import { AUTH_CONFIG, authUrl } from '@/lib/auth-config';

import type { SubscriptionTier } from '@/lib/subscriptionPolicy';

export interface UserStateBlob {
  lastComposeOutcome?: string;
  lastVisitedRoute?: string;
  updatedAt?: string;
  guestMode?: boolean;
  subscriptionTier?: SubscriptionTier;
  subscriptionStatus?: 'active' | 'guest' | 'none';
  planSelectedAt?: string;
  [key: string]: unknown;
}

export async function fetchUserState(): Promise<UserStateBlob | null> {
  if (AUTH_CONFIG.mock) return null;
  try {
    const res = await fetch(authUrl(AUTH_CONFIG.userState.get), { credentials: 'include' });
    if (!res.ok) return null;
    const json = (await res.json()) as { ok?: boolean; state?: UserStateBlob };
    return json.state ?? null;
  } catch {
    return null;
  }
}

export async function patchUserState(patch: UserStateBlob): Promise<UserStateBlob | null> {
  if (AUTH_CONFIG.mock) return patch;
  try {
    const res = await fetch(authUrl(AUTH_CONFIG.userState.patch), {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(patch),
    });
    if (!res.ok) return null;
    const json = (await res.json()) as { ok?: boolean; state?: UserStateBlob };
    return json.state ?? null;
  } catch {
    return null;
  }
}
